import { useUserSettings } from './useUserSettings';

export interface DateTimeSettings {
  timezone: string;
  timeFormat: '12' | '24';
  showSeconds: boolean;
  autoSync: boolean;
}

const defaultSettings: DateTimeSettings = {
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  timeFormat: '12',
  showSeconds: false,
  autoSync: true,
};

export const useDateTimeSettings = () => {
  const { settings, updateSetting, isLoaded } = useUserSettings('dateTime', defaultSettings);

  const updateSettings = (newSettings: Partial<DateTimeSettings>) => {
    Object.entries(newSettings).forEach(([key, value]) => {
      updateSetting(key, value);
    });
  };

  const getCurrentTime = () => {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      timeZone: settings.timezone,
      hour12: settings.timeFormat === '12',
      hour: 'numeric',
      minute: '2-digit',
      ...(settings.showSeconds && { second: '2-digit' }),
    };
    
    return now.toLocaleTimeString('en-US', options);
  };

  return {
    settings: settings as DateTimeSettings,
    updateSettings,
    getCurrentTime,
    isLoaded,
  };
};